module.exports = __webpack_public_path__ + "img/careerfirst.60fb46d6.png";